export default function calendarContextKey(user) {
  if (!user || !user.schoolId || !user.id) return '';
  return JSON.stringify([user.accountId, user.id, user.schoolId, user.role, user.activeContextKey, user.clientId, user.teacherId]);
}
